module.exports = __webpack_public_path__ + "static/media/Instructions.afdc1bc1.mp3";